module.exports = __webpack_public_path__ + "img/main-slide-mobile-2.e87fd61f.jpeg";